// Copyright (c) 2020 Deere & Company

export default Object.freeze( {
    ADD_SUCCESS_ALERT_MESSAGE: 'ADD_SUCCESS_ALERT_MESSAGE',
    DISCARD_ALERT_MESSAGES: 'DISCARD_ALERT_MESSAGES',
    ADD_ERROR_ALERT_MESSAGE: 'ADD_ERROR_ALERT_MESSAGE',
    DECREASE_BUSY_COUNTER: 'DECREASE_BUSY_COUNTER',
    INCREASE_BUSY_COUNTER: 'INCREASE_BUSY_COUNTER',
    RESET_BUSY_COUNTER: 'RESET_BUSY_COUNTER',
    RESET_UNIT: 'RESET_UNIT',
    SET_REPORTS: 'SET_REPORTS',
    SET_UNIT: 'SET_UNIT',
    UPDATE_OKTA_STATE_ACCESS_TOKEN: 'UPDATE_OKTA_STATE_ACCESS_TOKEN',
    UPDATE_OKTA_STATE_IS_AUTHENTICATED: 'UPDATE_OKTA_STATE_IS_AUTHENTICATED',
    UPDATE_OKTA_STATE_USER_FIRST_NAME: 'UPDATE_OKTA_STATE_USER_FIRST_NAME'
} );
